import instance from "../axios";

export const getAll = async () => {
  const response = await instance.get(`categories`);
  return response.data;
};
export const getForPO = async () => {
  const response = await instance.get(`categories/getForPO`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`categories`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`categories`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`categories/` + id);
  return response;
};
